export const Chapter = ({ number, kicker, title, dark = false }) => (
  <div className="mb-12 md:mb-16">
    <p
      className={`font-mono text-xs tracking-[0.25em] uppercase mb-5 ${
        dark ? "text-clinic-light" : "text-clinic"
      }`}
    >
      {number} — {kicker}
    </p>
    <h2
      className={`font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight max-w-3xl ${
        dark ? "text-paper" : "text-ink"
      }`}
    >
      {title}
    </h2>
  </div>
);
